import { render } from "./WxLogin.vue?vue&type=template&id=2fdea4f2"
import script from "./WxLogin.vue?vue&type=script&lang=js"
export * from "./WxLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__